/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespSeoLinks_viewer = {|
  +isMoreWaysToBrowseEnabled: ?boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSeoLinks_viewer",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isMoreWaysToBrowseEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "MORE_WAYS_TO_BROWSE",
          "type": "String!"
        }
      ],
      "name": "isEnabledByLocale",
      "storageKey": "isEnabledByLocale{\"featureName\":\"MORE_WAYS_TO_BROWSE\"}"
    }
  ],
  "type": "Viewer"
};

module.exports = fragment;
